/*
 * cart-drawer-bag-upsell.js
 * Handles the "Add bags" button + variant selector inside the cart drawer.
 * Uses event delegation so it works after the drawer re-renders.
 *
 * For multi-variant bag products, changing the dropdown updates the
 * displayed price/badge/image, and the Add button always adds the
 * currently selected variant.
 */
(function () {
  'use strict';

  var BUSY = false;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshCart() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (drawer) {
      drawer.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function getRoot(el) {
    return el.closest('[data-cart-bag-upsell]');
  }

  function getSelect(root) {
    return root && root.querySelector('[data-pdp-bag-upsell-variant-select]');
  }

  function currentVariantId(root) {
    var select = getSelect(root);
    if (select && select.value) return select.value;
    var btn = root && root.querySelector('[data-cart-bag-upsell-add]');
    return btn && btn.getAttribute('data-variant-id');
  }

  function updateDisplay(root) {
    var select = getSelect(root);
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var price = opt.getAttribute('data-price');
    var compare = opt.getAttribute('data-compare');
    var savings = opt.getAttribute('data-savings');
    var image = opt.getAttribute('data-image');
    var now = root.querySelector('[data-pdp-bag-upsell-now]');
    var was = root.querySelector('[data-pdp-bag-upsell-was]');
    var badge = root.querySelector('[data-pdp-bag-upsell-badge]');
    var img = root.querySelector('[data-pdp-bag-upsell-image]');
    if (now && price) now.innerHTML = price;
    if (was) {
      if (compare) { was.innerHTML = compare; was.hidden = false; }
      else { was.hidden = true; }
    }
    if (badge) {
      if (savings) {
        var label = (badge.getAttribute('data-label') || 'SAVE');
        badge.innerHTML = label + '&nbsp;' + savings;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }
    if (img && image) img.setAttribute('src', image);
    // Keep the Add button's data-variant-id in sync.
    var btn = root.querySelector('[data-cart-bag-upsell-add]');
    if (btn) btn.setAttribute('data-variant-id', select.value);
  }

  function addBag(root) {
    if (BUSY) return;
    var variantId = currentVariantId(root);
    if (!variantId) return;
    BUSY = true;

    var btn = root.querySelector('[data-cart-bag-upsell-add]');
    var text = btn && btn.querySelector('.pdp-bag-upsell__btn-text');
    var spinner = btn && btn.querySelector('.pdp-bag-upsell__btn-spinner');
    var originalLabel = text ? text.textContent : '';

    if (btn) btn.disabled = true;
    if (text) text.hidden = true;
    if (spinner) spinner.hidden = false;

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add.js failed (' + res.status + ')');
        return res.json();
      })
      .then(function () { refreshCart(); })
      .catch(function (err) {
        console.error('[cart-drawer-bag-upsell]', err);
        if (text) { text.textContent = 'Try again'; text.hidden = false; }
        if (spinner) spinner.hidden = true;
        if (btn) btn.disabled = false;
        setTimeout(function () { if (text) text.textContent = originalLabel; }, 2500);
      })
      .finally(function () { BUSY = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-bag-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var root = getRoot(btn);
    if (root) addBag(root);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-pdp-bag-upsell-variant-select]');
    if (!sel) return;
    var root = getRoot(sel);
    if (root && root.matches('[data-cart-bag-upsell]')) {
      updateDisplay(root);
    }
  });
})();
